module.exports = __webpack_public_path__ + "img/makeOnline.cf436041.png";